import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "The Map", id: "map" },
  { label: "Where We'll Be", id: "schedule" },
  { label: "Our Cart", id: "promo" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-sc-blue/90 backdrop-blur-md shadow-[0_4px_20px_rgba(44,42,40,0.07)]" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center group"
          data-testid="brand-logo"
        >
          <img
            src="/logo-santachiara.png"
            alt="Santa Chiara"
            className="h-9 md:h-11 w-auto group-hover:scale-105 transition-transform drop-shadow-[0_1px_2px_rgba(44,42,40,0.25)]"
          />
        </button>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-medium text-sc-espresso/80 hover:text-sc-espresso relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-sc-gold hover:after:w-full after:transition-all after:duration-300"
              data-testid={`nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("booking")}
            className="px-5 py-2.5 rounded-full bg-sc-espresso text-sc-cream text-sm font-medium hover:-translate-y-0.5 transition-transform"
            data-testid="nav-book-cta"
          >
            Book Our Cart
          </button>
        </div>
      </nav>
    </motion.header>
  );
}
